import { Component, OnDestroy, OnInit } from "@angular/core";
import { TimetrackingService } from "./timetracking.service";
import { takeUntil } from "rxjs/operators";
import { BehaviorSubject, Subject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { DateTime } from "luxon";
import { IUser } from "../admin/users/models/IUser";
import { CurrentUserService } from "../shared/services/current-user.service";
import { Router } from "@angular/router";
import { ModalRouteService } from "../shared/services/modal-route.service";
import { IProject } from "../admin/projects/shared/models/IProject";
import { TimeAddService } from "./time-add/time-add.service"
import {
  TimeCalendarView,
  TimeCalendarNavigation,
  TimeCalendarComponent,
} from "../shared/components/time-calendar/time-calendar.component";

interface ICalendarTab {
  label: string;
  view: TimeCalendarView;
}

@Component({
  selector: "app-timetracking",
  templateUrl: "./timetracking.component.html",
  styleUrls: ["./timetracking.component.scss"],
})
export class TimetrackingComponent implements OnInit, OnDestroy {
  private destroy = new Subject<any>();
  private calendarNavigationSubject = new Subject<TimeCalendarNavigation>();
  private userSubject = new BehaviorSubject<IUser>(null);

  user$ = this.userSubject.asObservable();

  calendarNav$ = this.calendarNavigationSubject.asObservable();

  CalendarTabs = {
    Day: {
      label: "Day",
      view: TimeCalendarView.Day,
    },
    Week: {
      label: "Week",
      view: TimeCalendarView.Week,
    },
    Month: {
      label: "Month",
      view: TimeCalendarView.Month,
    },
  };

  private calendarViewSubject = new BehaviorSubject<TimeCalendarView>(
    TimeCalendarView.Week
  );
  calendarView$ = this.calendarViewSubject.asObservable();

  activeTab = this.CalendarTabs.Week; // TODO activetabe and calendarviewsubject should be related so that if we change something we dont forget to change the other
  lastDateSelected: DateTime = DateTime.local();

  constructor(
    private timetrackingService: TimetrackingService,
    private http: HttpClient,
    private modalService: ModalRouteService,
    private currentUserService: CurrentUserService,
    private router: Router,
    private timeAddService: TimeAddService
  ) {
    currentUserService.currentUserData$
      .pipe(takeUntil(this.destroy))
      .subscribe((userData) => {
        this.userSubject.next(userData);
      });
  }

  ngOnInit() { }
  ngOnDestroy() {
    this.destroy.next();
  }
  addEntry() {
    this.addEntryForDay({ day: this.timeAddService.getLastDateSelected() });
  }
  viewDay({ project, day }: { project: IProject; day: DateTime }) {
    this.modalService.openModal("modal/time", {
      workday: day,
      userid: this.userSubject.value.id,
      projectid: project ? project.id : undefined,
    });
  }
  addEntryForDay({ project, day }: { project?: IProject; day: DateTime }) {
    this.timeAddService.setLastDateSelected(day);
    this.modalService.openModal("modal/time/add", {
      workday: day,
      userid: this.userSubject.value.id,
      projectid: project ? project.id : undefined,
      lastSelectedDate: this.lastDateSelected.toISODate(),
    });
  }
  changeTab(tab: ICalendarTab) {
    this.calendarViewSubject.next(tab.view);
  }
  previousPeriod() {
    this.calendarNavigationSubject.next(TimeCalendarNavigation.Prev);
  }
  nextPeriod() {
    this.calendarNavigationSubject.next(TimeCalendarNavigation.Next);
  }
  showToday() {
    this.calendarNavigationSubject.next(TimeCalendarNavigation.Today);
  }
}
